var MyTrackerStatus;
(function(MyTrackerStatus) {
    MyTrackerStatus[MyTrackerStatus["OFF"] = 0] = "OFF";
    MyTrackerStatus[MyTrackerStatus["ON"] = 1] = "ON";
    MyTrackerStatus[MyTrackerStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
})(MyTrackerStatus || (MyTrackerStatus = {}));

export { MyTrackerStatus };
